import useTrustedEmailSender, {
  trustedEmailSenderState
} from 'Hooks/useTrustedEmailSender'
import { evalCondition } from 'mailup-react-helpers'
import {
  FormElement,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
  TrustedEmailInput
} from 'mailup-web-components'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { stepState } from 'Pages/Campaign/recoil/state/page'

import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

const InputSenderEmail = () => {
  const intl = useIntl()
  const [
    {
      step3: {
        senderInfo: { listInfoDetailsLoaded }
      }
    },
    setStepState
  ] = useRecoilState(stepState)

  const {
    EmailOptions: { SenderEmail }
  } = useRecoilValue(campaignState)
  const setCampaignState = useSetRecoilState(campaignState)

  const setTrustedEmailState = useSetRecoilState(
    trustedEmailSenderState('trustedSender')
  )

  const handleRegisterSuccess = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.EmailSendMessage'
      }),
      TOAST_VARIANT_SUCCESS
    )
  }

  const handleRegisterError = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.LoadingDataError'
      }),
      TOAST_VARIANT_ERROR
    )
  }

  const trustedSenderProps = useTrustedEmailSender(
    'trustedSender',
    true,
    SenderEmail,
    handleRegisterSuccess,
    handleRegisterError
  )

  useEffect(() => {
    if (listInfoDetailsLoaded) {
      setTrustedEmailState((prev) => ({
        ...prev,
        value: SenderEmail || undefined
      }))
    }
  }, [listInfoDetailsLoaded])

  useEffect(() => {
    if (!listInfoDetailsLoaded) {
      return
    }
    setCampaignState((prev) => ({
      ...prev,
      isDirty: true,
      EmailOptions: {
        ...prev.EmailOptions,
        SenderEmail: trustedSenderProps.value
      }
    }))

    setStepState((prev) => ({
      ...prev,
      step3: {
        ...prev.step3,
        senderInfo: {
          ...prev.step3.senderInfo,
          // vuol dire che la prima volta che arriva in pagina senderEmailIsDirty
          // è false e trustedSenderProps.value è vuoto
          // quindi è corretto che rimane false
          senderEmailIsDirty: !(
            prev.step3.senderInfo.senderEmailIsDirty === false &&
            !trustedSenderProps.value
          )
        }
      }
    }))
  }, [trustedSenderProps.value])

  useEffect(() => {
    if (!listInfoDetailsLoaded) {
      return
    }
    setStepState((prev) => ({
      ...prev,
      step3: {
        ...prev.step3,
        senderInfo: {
          ...prev.step3.senderInfo,
          sernderEmailTrustedVariant: trustedSenderProps.variant,
          sernderEmailValid:
            trustedSenderProps.variant === 'success' ||
            trustedSenderProps.variant === 'neutral' ||
            trustedSenderProps.variant === 'warning' ||
            trustedSenderProps.variant === 'error'
        }
      }
    }))
  }, [trustedSenderProps.variant])

  return (
    <>
      <FormElement
        required
        label={intl.formatMessage({
          id: 'Load.Common.SenderEmailLabel'
        })}
        labelHelp={intl.formatMessage({
          id: 'Load.Common.SenderEmailTooltip'
        })}
      >
        <div data-mu-test='campaign-wizard-input-sender-email'>
          <TrustedEmailInput
            id='trustedSender'
            disabled={evalCondition('uo:EMAILSENDERLOCKED')}
            {...trustedSenderProps}
          />
        </div>
      </FormElement>
    </>
  )
}

export default InputSenderEmail
